import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import DOMPurify from 'isomorphic-dompurify';
export default {
  name: 'RemoteSVG',
  props: {
    url: {
      type: String,
      default: undefined,
      validator: function validator(value) {
        try {
          // eslint-disable-next-line no-new
          new URL(value);
          return true;
        } catch (error) {
          return false;
        }
      }
    },
    html: {
      type: String,
      default: undefined
    }
  },
  data: function data() {
    return {
      svgContent: undefined
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response, content, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this.html) {
              _context.next = 1;
              break;
            }
            _this.svgContent = _this.sanitizeHTML(_this.html);
            _context.next = 7;
            break;
          case 1:
            if (!_this.url) {
              _context.next = 7;
              break;
            }
            _context.prev = 2;
            _context.next = 3;
            return fetch(_this.url);
          case 3:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return response.text();
          case 4:
            content = _context.sent;
            _this.svgContent = _this.sanitizeHTML(content);
          case 5:
            _context.next = 7;
            break;
          case 6:
            _context.prev = 6;
            _t = _context["catch"](2);
            console.error('🚀 ~ file: RemoteSVG.vue ~ e', _t);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 6]]);
    }))();
  },
  methods: {
    sanitizeHTML: function sanitizeHTML(html) {
      return DOMPurify.sanitize(html, {
        USE_PROFILES: {
          svg: true
        }
      });
    }
  }
};